import { browser } from '$app/environment';

class Endpoint {
  /**
   * Return application API endpoint
   * @returns String
   */
  public get(): string {
    return this.getEndpoint() || this.getDefaultEndpoint();
  }

  private getDefaultEndpoint(): string {
    return import.meta.env.VITE_API_END_POINT;
  }

  public getAtlasEndpoint(): string {
    return import.meta.env.VITE_ATLAS_API_END_POINT;
  }

  private getEndpoint(): string {
    if (browser) {
      const HostEnds = '.verifiable.com';
      if (!window.location.host.endsWith(HostEnds)) return '';

      return `${window.location.origin}/api/`;
    }
    return '';
  }
}

export const endpoint = new Endpoint();
